export const PDF_STAGE_WIDTH_PX = 560
export const PDF_STAGE_HEIGHT_PX = Math.round(PDF_STAGE_WIDTH_PX * Math.SQRT2)
